module.exports = __webpack_public_path__ + "img/strategy.74cd1ca1.png";